import { Controller } from "@hotwired/stimulus"
import { createWidget } from '@typeform/embed'


export default class extends Controller {
  static values = {
    id: String,
    studentResourceSessionId: String,
    preview: Boolean
  }
  static targets = ["container", "form", "button"]

  connect() {
    createWidget(this.idValue, {
      container: this.containerTarget,
      hideHeaders: true,
      hideFooter: true,
      enableSandbox: this.previewValue,
      keepSession: false,
      hidden: {
        
        student_resource_session_id: this.studentResourceSessionIdValue,
      },
      onSubmit: () => {
        this.handleSubmitButtonClick();
      },
      onEndingButtonClick: () => {
        this.handleEndingButtonClick();
      }
    })
  }

  handleEndingButtonClick() {
    this.buttonTarget.click();
  }

  handleSubmitButtonClick() {
  }
}
